(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  const productInformation = document.querySelector('.product-information');
  if (!productInformation) return;

  const mediaContainer = productInformation.querySelector('.product-information__media');
  const mediaGallery = mediaContainer?.querySelector('media-gallery');
  const deferredMedia = mediaContainer?.querySelector('deferred-media.product-information__custom-video');

  if (!mediaGallery || !deferredMedia) return;

  const playDeferredMedia = () => {
    if (deferredMedia.hasAttribute('data-media-loaded')) {
      if (typeof deferredMedia.playMedia === 'function') deferredMedia.playMedia();
    } else if (typeof deferredMedia.showDeferredMedia === 'function') {
      deferredMedia.showDeferredMedia();
    }
  };

  const handleTabChange = (event) => {
    const tab = event.detail.tab;
    const shouldSwitchToVideo = tab.hasAttribute('data-switch-to-video');

    if (shouldSwitchToVideo) {
      mediaGallery.style.display = 'none';
      deferredMedia.classList.remove('is-hidden');
      playDeferredMedia();
    } else {
      mediaGallery.style.display = '';
      deferredMedia.classList.add('is-hidden');
      if (typeof deferredMedia.pauseMedia === 'function') deferredMedia.pauseMedia();
    }
  };

  productInformation.addEventListener('tabs:change', handleTabChange);

  const firstTab = productInformation.querySelector('.layout-main-content [role="tab"][aria-selected="true"]');
  if (firstTab && firstTab.hasAttribute('data-switch-to-video')) {
    mediaGallery.style.display = 'none';
    deferredMedia.classList.remove('is-hidden');
    playDeferredMedia();
  }

  } catch(e) { console.error(e); }
})();
})();
